"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var serviceURL = "/contentpanelservice/v1/api";
var config = {
  contentPanel: serviceURL + "/content-panel",
  interaction: serviceURL + "/interaction-panel/template",
  interactionFinal: serviceURL + "/interaction-panel",
  cpFolder: serviceURL + "/content-panel/folder-view",
  rgcpHtml: serviceURL + "/report-panel",
  rgcpHtmlMap: serviceURL + "/report-panel/mapping",
  cpSite: serviceURL + "/content-panel/site",
  cpReport: serviceURL + "/content-panel/report",
  activeBroadcast: serviceURL + "/active-broadcast",
  templateStructure: serviceURL + "/template-structure",
  standardTemplate: serviceURL + "/standard/template"
};
exports.config = config;